import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlResolverPipeStrategy } from 'src/app/modules/url-resolver/url-resolver-pipe-strategy.interface';
import { FirebaseStorageService } from './firebase-storage.service';

@Pipe({ name: 'firebaseUrl' })
export class FirebaseUrlPipe implements PipeTransform, UrlResolverPipeStrategy {
  constructor(private firebaseStorageService: FirebaseStorageService) {}

  canHandle(url: string): boolean {
    return url.startsWith('gs://');
  }

  transform(gsUrl: string): Observable<string> {
    return this.firebaseStorageService.resolve(gsUrl);
  }
}
